import { useEffect, useState } from "react";

const reduced = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const Tagline = ({ phrases = [], color, start = 0, testid = "lp-tagline-band" }) => {
  const [i, setI] = useState(start % Math.max(phrases.length, 1));
  useEffect(() => {
    if (phrases.length < 2 || reduced()) return undefined;
    const t = setInterval(() => setI((n) => (n + 1) % phrases.length), 2700);
    return () => clearInterval(t);
  }, [phrases.length]);
  if (!phrases.length) return null;
  return (
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-3 px-5 pb-6 pt-24 text-center md:gap-5 md:pb-12 md:pt-32" data-testid={testid} aria-live="off">
      <span className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-500 md:text-sm">We help you</span>
      <span className="grid w-full place-items-center">
        {phrases.map((p, n) => (
          <span key={p} data-testid={`${testid}-${n}`} aria-hidden={n !== i}
            className={`lp-serif text-[44px] italic leading-tight transition-opacity duration-700 ease-in-out [grid-area:1/1] md:text-[64px] lg:whitespace-nowrap lg:text-[88px] ${n === i ? "opacity-100" : "opacity-0"}`} style={{ color }}>{p}</span>
        ))}
      </span>
    </div>
  );
};
